import { render, staticRenderFns } from "./FundsInfo.vue?vue&type=template&id=99f7c04e&scoped=true"
import script from "./FundsInfo.vue?vue&type=script&lang=js"
export * from "./FundsInfo.vue?vue&type=script&lang=js"
import style0 from "./FundsInfo.vue?vue&type=style&index=0&id=99f7c04e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f7c04e",
  null
  
)

export default component.exports